import { put, takeEvery } from 'redux-saga/effects';
import { initializeCompliantLocalStorage } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/actions';
import { appMounted } from '../app/actions';

function* handleAppMounted() {
  yield put(initializeCompliantLocalStorage());
}

// Since local storage relies on the global `window` param
export default function* saga() {
  yield takeEvery(appMounted, handleAppMounted);
}
